import React, {Component} from 'react';
import {
  Avatar,
  Badge,
  Chip,
  Divider,
  Grid,
  Paper,
  Typography,
} from 'material-ui';
import * as firebase from 'firebase';
import {Helmet} from 'react-helmet';
import _ from 'lodash';
import HeaderBar from './components/HeaderBar';

const styles = {
  paperContainer: {
    padding: '1rem',
  },
  chaosAvatar: {
    backgroundColor: 'red',
  },
  normalAvatar: {
    backgroundColor: 'green',
  },
  badge: {
    color: 'white',
  },
};

class Gamepage extends Component {
  constructor() {
    super();
    this.state = {
      game: undefined,
    };
  }

  componentDidMount() {
    const gameRef = firebase
      .database()
      .ref('games')
      .child(this.props.match.params.gameId);
    gameRef.on('value', snap => {
      this.setState({
        game: snap.val(),
      });
    });
  }

  getGameDetailComponent = game => {
    const gameModeBadge = (
      <Chip
        label={game.mode}
        avatar={
          <Avatar
            style={
              game.mode === 'chaos' ? styles.chaosAvatar : styles.normalAvatar
            }
          >
            {game.mode.charAt(0)}
          </Avatar>
        }
      />
    );
    const winnerComponent = this.getPlayerComponent(game.players[game.winner]);
    return (
      <Paper style={styles.paperContainer}>
        <h3>Game Summary</h3>
        <h5>Mode</h5>
        <div>{gameModeBadge}</div>
        <h5>Winner</h5>
        <Grid container>
          <Grid item xs={8}>
            {winnerComponent}
          </Grid>
          <Grid item xs={4}>
            <div style={{display: 'table', height: '100%'}}>
              <span style={{display: 'table-cell', verticalAlign: 'middle'}}>
                {game.scores[game.winner]}
              </span>
            </div>
          </Grid>
        </Grid>
      </Paper>
    );
  };

  getLinkDescription = game => {
    const {players} = game;
    const playersName = Object.keys(players)
      .map(playerId => ` ${players[playerId].first_name}`)
      .join(',')
      .replace(/,([^,]*)$/, ' dan$1');
    return `Adu jempol antara${playersName}`;
  };

  renderGameReport = () => {
    if (!this.state.game) {
      return null;
    }
    return (
      <div
        style={{
          paddingLeft: '.8rem',
          paddingRight: '.8rem',
        }}
      >
        <Grid container>
          <Grid item xs={12} md={4}>
            <div style={{paddingBottom: '.5rem'}}>
              {this.getGameDetailComponent(this.state.game)}
            </div>
            <div style={{paddingTop: '.5rem'}}>
              {this.getPlayerListComponent(this.state.game.players)}
            </div>
          </Grid>
          <Grid item xs={12} md={8}>
            {this.getGameSummaryComponent(this.state.game)}
            {this.getGameTimeline(this.state.game.rounds)}
          </Grid>
        </Grid>
      </div>
    );
  };

  generateTotalThumbs = thumbs => {
    return Object.keys(thumbs).reduce((prev, id) => {
      if (!thumbs[id]) {
        return prev;
      }
      let thumbString = '';
      for (var i = 0; i < thumbs[id]; i++) {
        thumbString += '👍';
      }
      if (prev === '🚫') {
        return thumbString;
      }
      return (prev += thumbString);
    }, '🚫');
  };

  generateRoundScore = scores => {
    const scoreArray = Object.keys(scores).map(playerId => {
      return {
        id: playerId,
        score: scores[playerId],
      };
    });
    const sortedScore = _.reverse(_.sortBy(scoreArray, 'score'));
    return sortedScore.map(playerScore => {
      return (
        <div
          style={{display: 'inline-block', margin: '.8rem'}}
          key={`score-${playerScore.id}`}
        >
          <Badge badgeContent={playerScore.score} color="primary">
            {this.getPlayerComponent(
              this.state.game.players[playerScore.id],
              false
            )}
          </Badge>
        </div>
      );
    });
  };

  getGameTimeline = rounds => {
    return rounds.map((round, index) => {
      return (
        <div
          key={`round-${index}`}
          style={{marginTop: '.3rem', marginBottom: '.3rem'}}
        >
          <Paper>
            <div style={styles.paperContainer}>
              <Typography type="headline" style={{marginBottom: '1.5rem'}}>
                Round {index + 1}
              </Typography>
              <Grid container>
                <Grid item xs={12} md={4}>
                  <Typography type="title" style={{marginBottom: '.5rem'}}>
                    Player Answer
                  </Typography>
                  <Divider />
                  <div style={{marginTop: '.5rem'}}>
                    <Grid container>
                      <Grid item xs={8}>
                        <div
                          style={{
                            display: 'inline-block',
                            verticalAlign: 'middle',
                            marginRight: '.5rem',
                          }}
                        >
                          {this.getPlayerComponent(
                            this.state.game.players[round.currentPlayer]
                          )}
                        </div>
                      </Grid>
                      <Grid item xs={4}>
                        <div style={{display: 'table', height: '100%'}}>
                          <Typography
                            type="display2"
                            style={{
                              color:
                                round.playerAnswer === round.correctAnswer
                                  ? 'green'
                                  : 'red',
                              display: 'table-cell',
                              verticalAlign: 'middle',
                              marginLeft: '.5rem',
                            }}
                          >
                            {round.playerAnswer}
                          </Typography>
                        </div>
                      </Grid>
                    </Grid>
                  </div>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography type="title" style={{marginBottom: '.5rem'}}>
                    Jumlah Jempol
                  </Typography>
                  <Divider />
                  <Typography type="title" style={{marginTop: '.8rem'}}>
                    {this.generateTotalThumbs(round.thumbs || {})}
                  </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                  <Typography type="title" style={{marginBottom: '.5rem'}}>
                    Skor
                  </Typography>
                  <Divider />
                  <div style={{marginTop: '.8rem'}}>
                    {this.generateRoundScore(round.scores)}
                  </div>
                </Grid>
              </Grid>
            </div>
          </Paper>
        </div>
      );
    });
  };

  getPlayerComponent = (player, full = true) => {
    const avatar = (
      <Avatar alt={`ava-${player.first_name}`} src={player.pictureUrl}>
        {player.pictureUrl ? null : player.first_name.charAt(0)}
      </Avatar>
    );
    if (!full) {
      return avatar;
    }
    return (
      <div style={{display: 'table'}}>
        <div style={{display: 'table-cell', verticalAlign: 'middle'}}>
          {avatar}
        </div>&nbsp;
        <span style={{display: 'table-cell', verticalAlign: 'middle'}}>
          {player.first_name}
        </span>
      </div>
    );
  };

  getPlayerListComponent = players => {
    const playerList = Object.keys(players).map(id => {
      const player = players[id];
      return (
        <div
          key={`player-${id}`}
          style={{marginTop: '.5rem', marginBottom: '.5rem'}}
        >
          {this.getPlayerComponent(player)}
        </div>
      );
    });
    return (
      <Paper style={styles.paperContainer}>
        <h3>Player List</h3>
        {playerList}
      </Paper>
    );
  };

  getGameStatistic = game => {
    const totalRound = game.rounds.length;
    const playerCopy = Object.assign({}, game.players);
    //  Construct statistic
    const correctRoundData = game.rounds.reduce(
      (prev, round) => {
        if (round.correctAnswer === round.playerAnswer) {
          prev.all = prev.all + 1;
          if (prev.player[round.currentPlayer].correct) {
            prev.player[round.currentPlayer].correct += 1;
          } else {
            prev.player[round.currentPlayer].correct = 1;
          }
        }
        if (prev.player[round.currentPlayer].round) {
          prev.player[round.currentPlayer].round += 1;
        } else {
          prev.player[round.currentPlayer].round = 1;
        }
        return prev;
      },
      {all: 0, player: playerCopy}
    );
    const percentage = correctRoundData.all / totalRound * 100;
    const playerArray = Object.keys(correctRoundData.player).map(playerId => {
      return {
        id: playerId,
        correct: correctRoundData.player[playerId].correct || 0,
        round: correctRoundData.player[playerId].round || totalRound,
      };
    });
    const playerCorrectSort = _.reverse(_.sortBy(playerArray, 'correct'));
    const playersAccurationComponent = playerCorrectSort.map(player => {
      const playerComponent = this.getPlayerComponent(game.players[player.id]);
      const playerCorrectRound = player.correct || 0;
      const playerRound = player.round;
      return (
        <div key={`statistic-${player.id}`}>
          <Grid container>
            <Grid item xs={6}>
              {playerComponent}
            </Grid>
            <Grid item xs={6}>
              <div style={{display: 'table', height: '100%'}}>
                <span style={{display: 'table-cell', verticalAlign: 'middle'}}>
                  {(playerCorrectRound / playerRound * 100).toFixed(0)}%
                </span>
              </div>
            </Grid>
          </Grid>
        </div>
      );
    });
    return (
      <div>
        <div style={{margin: '.3rem', marginBottom: '1rem'}}>
          Game Akurasi {percentage.toFixed(0)}%
        </div>
        <div style={{margin: '.3rem', marginTop: '1rem'}}>
          {playersAccurationComponent}
        </div>
      </div>
    );
  };

  getGameSummaryComponent = game => {
    const {chartUrl} = game;
    return (
      <div style={{marginBottom: '.3rem', marginTop: 0}}>
        <Paper>
          <div style={styles.paperContainer}>
            <Grid container>
              <Grid item xs={12} md={6}>
                <div>
                  <h5>Statistik</h5>
                  {this.getGameStatistic(game)}
                </div>
              </Grid>
              <Grid item xs={12} md={6}>
                <div>
                  <h5>Chart</h5>
                  <div style={{width: '100%'}}>
                    <img
                      src={chartUrl}
                      alt="gameChart"
                      style={{maxWidth: '100%'}}
                    />
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </Paper>
      </div>
    );
  };

  render() {
    return (
      <HeaderBar
        title={`Adu Jempol Game Report`}
        button="share"
        url={window.location.href}
      >
        {this.state.game ? (
          <Helmet>
            <meta property="og:image" content={this.state.game.chartUrl} />
            <meta property="og:url" content={window.location.href} />
            <meta
              property="og:description"
              content={this.getLinkDescription(this.state.game)}
            />
            <title>Game Summary</title>
          </Helmet>
        ) : null}
        {this.renderGameReport()}
      </HeaderBar>
    );
  }
}

export default Gamepage;



// WEBPACK FOOTER //
// ./src/Gamepage.js